import { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { modalsToggle } from 'actions';
import ConfirmModal from 'components/Modals/ConfirmModal';
import { useAcceptBidMutation } from 'services/api/offer-auction';
import { Vehicle } from 'types/vehicle';
import { useNoSelectorVehicleOfferAuctionById } from 'hooks';
import { ActionRow } from '../ActionRow';
import { formatCurrency } from 'utils';

type Props = {
  vehicle: Vehicle;
};

export const SellerAcceptedPublicOffer = ({ vehicle }: Props) => {
  const offerAuction = useNoSelectorVehicleOfferAuctionById(vehicle.id);
  const dispatch = useDispatch();
  const openModal = () => dispatch(modalsToggle(`acceptTopOffer-${vehicle.id}`));
  const sellerAcceptBid = offerAuction?.offerBids?.find(el => el.status === 'seller_accepted');
  const [acceptTopBid] = useAcceptBidMutation();

  if (!sellerAcceptBid) return null;

  const handleAccept = () => {
    acceptTopBid({ vehicle_id: vehicle.id, offer_id: sellerAcceptBid.id });
    dispatch(modalsToggle(`acceptTopOffer-${vehicle.id}`));
  };

  return (
    <Fragment>
      <ActionRow
        label={`Seller Accepted ${formatCurrency(sellerAcceptBid.amount)}`}
        buttonConfig={{
          label: 'Accept',
          handleClick: openModal
        }}
      />

      <ConfirmModal
        submitText="Accept"
        title="Are you sure you want to accept the offer?"
        modalId={`acceptTopOffer-${vehicle.id}`}
        handleSubmit={handleAccept}
      />
    </Fragment>
  );
};
